import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LOGOS } from '../../utils/consts';
import Button from '../Button/Button';
import { Switch } from 'antd';

export default function FloatingBanner({
  color,
  message,
  header,
  acceptText,
  denyText,
  onAccept,
  onDeny,
}) {
  const defaultConsent = {
    'ad_storage': true,
    'analytics_storage': true,
    'ad_user_data': true,
    'ad_personalization': true,
  };
  const [selection, setSelection] = useState(defaultConsent);
  return (
    <div
      className={`fixed bottom-0 inset-x-0`}
      style={{ zIndex: '2000' }}
    >
      <div className='w-full'>
        <div className={`p-2 rounded-lg bg-[#21898C] shadow-lg lg:py-10`}>
          <div className='flex flex-col items-center'>
            <div className='flex lg:flex-row flex-col gap-8 w-full justify-center items-center'>
              <img
                src={LOGOS.logotip}
                className='w-32 h-32'
              />
              <div className='w-2/3 text-white text-sm'>
                Our website uses cookies to customise content and advertisements, to send you offers
                aligned with your consumer preferences demonstrated while browsing, to provide
                social media functions and to analyse our web traffic. We share our information on
                how users interact with the website with our partners who take care of advertising,
                social media and internet data analysis, and who could combine this information with
                information you have provided to them, or which they have collected from your use of
                their services.
                <br />
                <br />
                Detailed information, such as the situation of your consent with the ID and the date
                on which you contacted us, can be found in our Policy Cookie page.
              </div>
              <div className='flex flex-col lg:gap-5'>
                <button
                  className='cta-btn__container_w dark w-full'
                  onClick={() => onAccept(defaultConsent)}
                >
                  Allow all
                </button>
                <button
                  className='cta-btn__container_w dark w-full'
                  onClick={() => onAccept(selection)}
                >
                  Allow selection
                </button>
                <button
                  className='cta-btn__container_w dark w-full'
                  onClick={() => onDeny()}
                >
                  Deny
                </button>
              </div>
            </div>
            <div className='mx-auto max-w-xl'>
              <hr className='tb__line' />
            </div>
            <div className='flex flex-row lg:gap-8 justify-center items-center lg:py-5'>
              <div className='flex flex-row gap-4 items-center'>
                <Switch
                  defaultChecked
                  onChange={(state) => setSelection({ ...selection, 'analytics_storage': state })}
                />
                <p className='text-white text-sm'>Necessary</p>
              </div>
              <div className='flex flex-row gap-4 items-center'>
                <Switch
                  defaultChecked
                  onChange={(state) => setSelection({ ...selection, 'ad_personalization': state })}
                />
                <p className='text-white text-sm'>Preferences</p>
              </div>
              <div className='flex flex-row gap-4 items-center'>
                <Switch
                  defaultChecked
                  onChange={(state) => setSelection({ ...selection, 'ad_user_data': state })}
                />
                <p className='text-white text-sm'>Statistics</p>
              </div>
              <div className='flex flex-row gap-4 items-center'>
                <Switch
                  defaultChecked
                  onChange={(state) => setSelection({ ...selection, 'ad_storage': state })}
                />
                <p className='text-white text-sm'>Marketing</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

FloatingBanner.propTypes = {
  color: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  acceptText: PropTypes.string.isRequired,
  denyText: PropTypes.string.isRequired,
  onAccept: PropTypes.func.isRequired,
  onDeny: PropTypes.func.isRequired,
};

FloatingBanner.defaultProps = {
  color: 'blue',
};
